/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  var slideshow = $( '#cbp-bislideshow' ),
    $items = slideshow.children( 'li' ),
    itemsCount = $items.length,
    // current item´s index
    current = 0,
    // timeout
    slideshowtime,
    // true if the slideshow is active
    isSlideshowActive = false,
    // it takes 3.5 seconds to change the background image
    interval = 3500,
    pageContentSlider,
    navSlider,
    tagebuchParentSlider,
    tagebuchChildSliders = [],
    hammertime,
    lastNavSlideIndex;

  var cbpBGSlideshow = {

    init: function( config ) {
      var self = this;
      // preload the images
      slideshow.imagesLoaded( function() {
        
        $items.each( function() {
          var $item = $( this );
          $item.css( 'background-image', 'url(' + $item.find( 'img' ).attr( 'src' ) + ')' );
        } );
        // show first item
        $items.eq( current ).css( 'opacity', 1 );
        // initialize/bind the events
        self.initEvents();
      });
      
    },

    initEvents: function() {
      var self = this;

      $('.cbp-bicontrols > span').on('click', function(e) {
        e.preventDefault();
        var $index = $(this).attr('data-bg-slide');
        var $slideIndex = parseInt($index) + 1;
        self.navigateTo($index);
        Sage.pageslider.navigateToSlide($slideIndex);
      });

      var backgroundSlider = document.getElementById('cbp-bislideshow');

      // Add swipe support with Hammer.js
      hammertime = new Hammer(backgroundSlider);
      hammertime.on('swipeleft', function(ev) {
        self.navigate('next');
        Sage.pageslider.next();
      });
      hammertime.on('swiperight', function(ev) {
        self.navigate('prev');
        Sage.pageslider.prev();
      });
    },

    navigate: function( direction ) {

      // current item
      var $oldItem = $items.eq( current );
      
      if( direction === 'next' && current < (itemsCount - 1) ) {
        current = current < itemsCount - 1 ? ++current : 0;
      }
      else if( direction === 'prev' && current > 0) {
        current = current > 0 ? --current : itemsCount - 1;
      } else {
        return;
      }

      // new item
      var $newItem = $items.eq( current );
      // show / hide items
      $oldItem.css( 'opacity', 0 ).removeClass('active');
      $newItem.css( 'opacity', 1 ).addClass('active');

    },

    navigateTo: function (index) {
      var $oldItem = $items.eq( current );
      
      current = index;

      // new item
      var $newItem = $items.eq( current );
      // show / hide items
      $oldItem.css( 'opacity', 0 ).removeClass('active');
      $newItem.css( 'opacity', 1 ).addClass('active');

      $('.cbp-bicontrols span').removeClass('active');
      $('.cbp-bicontrols span[data-bg-slide="' + current + '"]').addClass('active');
    },

    startSlideshow: function() {
      var self = this;
      isSlideshowActive = true;
      clearTimeout( slideshowtime );
      slideshowtime = setTimeout( function() {
        self.navigate( 'next' );
        self.startSlideshow();
      }, interval );

    },

    stopSlideshow: function() {
      isSlideshowActive = false;
      clearTimeout( slideshowtime );
    }

  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all page

        cbpBGSlideshow.init();

        pageContentSlider = $('.page-content__slides');

        pageContentSlider.owlCarousel({
          items: 1,
          singleItem: true,
          pagination: false,
          autoHeight: true,
          afterMove: function() {
            UTIL.fire('pageslider', 'moved');
          },
          addClassActive: true
        });

        // Fire line animation if not bautagebuch page
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
          $('body').addClass('device');
        } else if (!$('.page-template-page-bautagebuch').length && !$('.page-template-page-presse').length) {
          $('.svg-s').interactive_bg({
            strength: 35,               // Movement Strength when the cursor is moved. The higher, the faster it will reacts to your cursor. The default value is 25.
            scale: 1,                   // The scale in which the background will be zoomed when hovering. Change this to 1 to stop scaling. The default value is 1.05.
            animationSpeed: "500ms",    // The time it takes for the scale to animate. This accepts CSS3 time function such as "100ms", "2.5s", etc. The default value is "100ms".
            contain: true,              // This option will prevent the scaled object/background from spilling out of its container. Keep this true for interactive background. Set it to false if you want to make an interactive object instead of a background. The default value is true.
            wrapContent: false          // This option let you choose whether you want everything inside to reacts to your cursor, or just the background. Toggle it to true to have every elements inside reacts the same way. The default value is false
          });
        }

        // Make background object responsive
        $(window).resize(function() {
          $('.svg-s > .ibg-bg').css({
            width: ($(window).outerWidth() * 1.20)
          });
        });

        $('.js-course-register').click(function(e) {
          e.preventDefault();
          $('body').addClass('course-signup-form-active');
          $('.content-info').removeClass('show');
        });

        $('.js-toggle-contact-form').click(function(e) {
          e.preventDefault();
          $('body').addClass('contact-form-active');
          $('.content-info').removeClass('show');
        });

        $('.course-signup-form__closebutton').on('touchstart click', function(e) {
          e.preventDefault();
          $('body').removeClass('course-signup-form-active');
        });

        $('.contact-form__closebutton').on('touchstart click', function(e) {
          e.preventDefault();
          $('body').removeClass('contact-form-active');
        });

        $('.js-toggle-page-content').click(function(e) {
          e.preventDefault();
          $(this).next('.page-content__slides-wrapper').slideToggle();
        });

        $('.page-content__bottom-prev').click(function(e) {
          e.preventDefault();
          UTIL.fire('pageslider', 'prev');
        });

        $('.page-content__bottom-next').click(function(e) {
          e.preventDefault();
          UTIL.fire('pageslider', 'next');
        });

        $('.page-content__bottom-number').click(function(e) {
          e.preventDefault();
          var index = $(this).attr('data-slide');
          UTIL.fire('pageslider', 'navigateToSlide', index);
        });

        $('.page-content__bottom-readmore').click(function(e) {
          e.preventDefault();
          UTIL.fire('pageslider', 'next');
        });

        $('.page-content__bottom-readless').click(function(e) {
          e.preventDefault();
          UTIL.fire('pageslider', 'navigateToSlide', 1);
        });

        $('.content-info__title').click(function(e) {
          e.preventDefault();
          $(this).parent().toggleClass('show');
        });

        $('.menubar__menubutton').on('touchstart, click', function(e) {
          e.preventDefault();
          $('body').toggleClass('menu-active');
        });

        $('.menubar__closebutton').on('touchstart click', function(e) {
          e.preventDefault();
          $('body').toggleClass('menu-active');
        });

        // $('.footer__impressum').on('touchstart click', function(e) {
        //   e.preventDefault();
        //   $('body').addClass('impressum-active');
        //   $('.content-info').removeClass('show');
        // });

        $('.impressum__closebutton').on('touchstart click', function(e) {
          e.preventDefault();
          $('body').removeClass('impressum-active');
        });

        // $('.footer__datenschutz').on('touchstart click', function(e) {
        //   e.preventDefault();
        //   console.log('click');
        //   $('body').addClass('datenschutz-active');
        //   $('.content-info').removeClass('show');
        // });

        $('.datenschutz__closebutton').on('touchstart click', function(e) {
          e.preventDefault();
          console.log('close');
          $('body').removeClass('datenschutz-active');
        });

        $('.cc-link').on('touchstart click', function(e) {
          e.preventDefault();
          $('body').addClass('datenschutz-active');
          $('.content-info').removeClass('show');
        });

        $('.content-table__aside-readmore').on('touchstart click', function(e) {
          e.preventDefault();
          $(this).toggleClass('active');
          $(this).prev('ul').find('li.hidden').slideToggle();
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $('body').addClass('loaded');
      }
    },

    // Home page
    'bautagebuch': {
      init: function() {

        // JavaScript to be fired on the bautagebuch page
        yearNav = $('.bautagebuch__year-nav');
        navSlider = $('.bautagebuch__nav-list');
        tagebuchParentSlider = $('.bautagebuch__slides');
        tagebuchChildSlider = $('.bautagebuch__slide-images');

        navSlider.owlCarousel({
          pagination: false,
          addClassActive: true,
          itemsMobile: [355, 1],
          itemsTabletSmall: [479, 2],
          itemsTablet: [768, 3],
          itemsDesktopSmall: [992, 4],
          itemsDesktop: [2780,5],
          rewindNav: false
        });

        tagebuchParentSlider.owlCarousel({
          items: 1,
          singleItem: true,
          autoHeight: true,
          slideSpeed: 500,
          pagination: false,
          rewindNav: false,
          mouseDrag: false,
          touchDrag: false,
          afterMove: function() {
            UTIL.fire('bautagebuch', 'tagebuchParentSliderMoved');
          }
        });

        $(tagebuchChildSlider).each(function() {
          var gallery_id = $(this).attr('data-gallery-id');
          tagebuchChildSliders[gallery_id] = $(this).owlCarousel({
            items: 1,
            singleItem: true,
            slideSpeed: 500,
            autoplay: false,
            autoHeight: false,
            pagination: false,
            lazyLoad: true,
            afterMove: function() {
              UTIL.fire('bautagebuch', 'tagebuchChildSliderMoved', gallery_id);
            }
          });
        });

        $('.bautagebuch__nav-control--left').click(function(e) {
          e.preventDefault();
          UTIL.fire('bautagebuch', 'navSliderPrev');
        });

        $('.bautagebuch__nav-control--right').click(function(e) {
          e.preventDefault();
          UTIL.fire('bautagebuch', 'navSliderNext');
        });

        $('.bautagebuch__year-nav-item').click(function(e) {
          e.preventDefault();
          var year = $(this).attr('data-year');

          $('.bautagebuch__year-nav-item').removeClass('active');
          $(this).addClass('active');

          $('.bautagebuch__nav-item').removeClass('selected');
          $('.bautagebuch__nav-item[data-year="' + year + '"]').first().addClass('selected');

          UTIL.fire('bautagebuch', 'navSliderNavigateToYear', year);
        });

        $('.bautagebuch__nav-item').on('touchstart click', function(e) {
          e.preventDefault();
          var index = $(this).attr('data-slide');
          var itemSelected = parseInt(index) - 1;
          $('.bautagebuch__nav-item').removeClass('selected');
          $(this).addClass('selected');
          tagebuchParentSlider.trigger('owl.goTo', [itemSelected]);
        });

        $('.bautagebuch__slide-nav-dot').click(function(e) {
          e.preventDefault();
          var index = $(this).attr('data-subslide');
          var galleryId = $(this).parent().attr('data-gallery-id');
          UTIL.fire('bautagebuch', 'tagebuchChildSliderNavigateTo', [index, galleryId]);
        });

      },
      navSliderNext: function() {
        var data = tagebuchParentSlider.data('owlCarousel');
        var nextItem = parseInt(data.currentItem) + 2;

        if (nextItem <= data.itemsAmount) {
          $('.bautagebuch__nav-item').removeClass('selected');
          $('.bautagebuch__nav-item[data-slide="' + nextItem + '"]').addClass('selected');
        }
        navSlider.trigger('owl.next');
        tagebuchParentSlider.trigger('owl.next');
      },
      navSliderPrev: function() {
        var data = tagebuchParentSlider.data('owlCarousel');
        var prevItem = parseInt(data.currentItem);

        if (prevItem >= 1) {
          $('.bautagebuch__nav-item').removeClass('selected');
          $('.bautagebuch__nav-item[data-slide="' + prevItem + '"]').addClass('selected');
        }
        navSlider.trigger('owl.prev');
        tagebuchParentSlider.trigger('owl.prev');
      },
      navSliderMoved: function() {
        var data = tagebuchParentSlider.data('owlCarousel');
        var currentSlide = data.currentItem + 1;
        var activeNavItem = $('.bautagebuch__nav-item[data-slide="' + currentSlide + '"]');
        var activeYear = activeNavItem.attr('data-year');

        $('.bautagebuch__year-nav-item').removeClass('active');
        if($('.bautagebuch__year-nav-item[data-year="' + activeYear + '"]').length) {
          $('.bautagebuch__year-nav-item[data-year="' + activeYear + '"]').addClass('active');
        } else {
          $('.bautagebuch__year-nav-item').last().addClass('active');
        }
      },
      tagebuchChildSliderMoved: function(child_id) {
        var data = tagebuchChildSliders[child_id].data('owlCarousel');
        var itemIndex = data.currentItem + 1;
        var galleryId = $(data.$elem).attr('data-gallery-id');
        $('.bautagebuch__slide-nav[data-gallery-id="' + galleryId + '"]').find('.bautagebuch__slide-nav-dot').removeClass('active');
        $('.bautagebuch__slide-nav[data-gallery-id="' + galleryId + '"]').find('.bautagebuch__slide-nav-dot[data-subslide="' + itemIndex + '"]').addClass('active');
      },
      tagebuchChildSliderNavigateTo: function(args) {
        var slideIndex = args[0] - 1;
        var galleryId = args[1];
        var slider = tagebuchChildSliders[galleryId].data('owlCarousel');
        slider.goTo(slideIndex);
      },
      tagebuchParentSliderMoved: function() {
        var data = tagebuchParentSlider.data('owlCarousel');

        if ((data.currentItem + 1) === data.itemsAmount) {
          $('.bautagebuch__nav').addClass('last-item');
        } else {
          $('.bautagebuch__nav').removeClass('last-item');
        }

        if (data.currentItem === 0) {
          $('.bautagebuch__nav').addClass('first-item');
        } else {
          $('.bautagebuch__nav').removeClass('first-item');
        }

        UTIL.fire('bautagebuch', 'navSliderMoved');

      },
      navSliderJumpToEnd: function() {
        if (navSlider.data('owlCarousel')) { // check if carousel is initialized (has items)
          var navSliderData = navSlider.data('owlCarousel');
          var parentSliderData = tagebuchParentSlider.data('owlCarousel');
          navSlider.trigger('owl.jumpTo', [navSliderData.itemsAmount - 1]);
          tagebuchParentSlider.trigger('owl.jumpTo', [parentSliderData.itemsAmount - 1]);
          $('.bautagebuch__nav-item').removeClass('selected');
          $('.bautagebuch__nav-item[data-slide="' + navSliderData.itemsAmount + '"]').addClass('selected');
          $('.bautagebuch__year-nav-item').last().addClass('active');
        }
      },
      navSliderNavigateTo: function() {
        var data = navSlider.data('owlCarousel');
        var slideIndex = data.currentItem - 1;
        navSlider.trigger('owl.goTo', [slideIndex]);
      },
      navSliderNavigateToYear: function(year) {
        var slideToGoTo = navSlider.find('.bautagebuch__nav-item[data-year="' + year + '"]').first();
        var slideIndex = parseInt( slideToGoTo.attr('data-slide') );
        navSlider.trigger('owl.goTo', [slideIndex - 1]);
        tagebuchParentSlider.trigger('owl.goTo', [slideIndex - 1]);
      },
      finalize: function() {
        // JavaScript to be fired on the bautagebuch page, after the init JS
        // Go to last item in Slider after everything is loaded
        UTIL.fire('bautagebuch', 'navSliderJumpToEnd');
      }
    },
    'pageslider': {
      moved: function() {
        var data = pageContentSlider.data('owlCarousel');

        var pageIndex = (data.currentItem + 1);
        var $buttons = $('.page-content__bottom-numbers');

        var $prevButton = $('.page-content__bottom-prev');
        var $readLessButton = $('.page-content__bottom-readless');

        var $nextButton = $('.page-content__bottom-next');
        var $readMoreButton = $('.page-content__bottom-readmore');

        $buttons.find('.page-content__bottom-number').removeClass('active').removeAttr('disabled');
        $buttons.find('[data-slide="'+ pageIndex +'"]').addClass('active').attr('disabled', 'disabled');

        if (pageIndex === 1 && !$prevButton.hasClass('hide')) {
          $prevButton.addClass('hide');
          $readLessButton.addClass('hide');
        } else {
          $prevButton.removeClass('hide');
          $readLessButton.addClass('hide');
        }

        if (pageIndex === data.itemsAmount && !$nextButton.hasClass('hide')) {
          $nextButton.addClass('hide');
          $readMoreButton.addClass('hide');
          $readLessButton.removeClass('hide');
        } else {
          $nextButton.removeClass('hide');
          $readMoreButton.removeClass('hide');
        }

        cbpBGSlideshow.navigateTo(data.currentItem); // Set background image
      },
      navigateToSlide: function(index) {
        var slideIndex = index - 1;
        pageContentSlider.trigger('owl.goTo', [slideIndex]);
      },
      next: function() {
        pageContentSlider.trigger('owl.next');
      },
      prev: function() {
        pageContentSlider.trigger('owl.prev');
      }
    }

  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
